import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeUriText',
  standalone: false,
})
export class EncodeUriTextPipe implements PipeTransform {
  transform(value: string): any {
    return encodeURIComponent(value);
  }
}
